export const OC_QUOTE_CART_PAGE = {
  desktop: `<div class="cui cui-grid cui-container">
  <div class="-spacing--top-40 -spacing--bottom-64">
    <div class="cui-row">
      <div class="cui-col-xl-8">
        <div class="cui-skeleton-heading -size--large -spacing--bottom-40 -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width: 100%;">
            <div class="display-flex -spacing--bottom-16">
              <div class="cui-skeleton__item cui-skeleton-heading__title cui-col-xl-4" style="width: min(300px, 100%);"></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--top-12 cui-col-xl-4 col-offset-4" style="width: min(300px, 100%);">
                <div class="cui-skeleton__item" style="height: 18px;"></div>
              </div>
            </div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div
          class="cui-skeleton-heading -size--medium -resolution--desktop display-none display-md-none display-lg-block display-xl-none -spacing--bottom-40"
          style="padding: 24px; border: 1px solid #D1D1D1;">
          <div class="cui-skeleton-heading__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: min(300px, 100%);"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
          <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div>
          </div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-40 -resolution--desktop">
          <div class="cui-skeleton__item" style="width: min(300px, 100%); height: 24px;"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8">
          <div class="cui-skeleton__item" style="width: 100%; height: 56px;"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8">
          <div class="cui-skeleton__item" style="width: 100%; height: 168px;"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8">
          <div class="cui-skeleton__item" style="width: 100%; height: 168px;"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 168px;"></div>
        </div>
      </div>
      <div class="cui-col-xl-4">
        <div class="cui-skeleton-heading -size--medium -resolution--desktop display-none display-xl-block"
             style="padding: 24px; border: 1px solid #D1D1D1;">
          <div class="cui-skeleton-heading__content" style="width: min(300px, 100%);">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
          <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`
};
